import React from "react";
import { TableContext, useTable } from "@hook";
import { PageTemplate } from "@component";
import { ContentStatisticsContainer } from "@container";
import moment from "moment/moment";

const ContentStatistics = () => {
  const tableState = useTable({
    initial: {
      fromDateTime: moment().subtract(7, "days"),
      searchTypes: {
        type: 'TITLE',
        condition: 'POSITIVE'
      }
    }
  })
  return (
    <TableContext.Provider value={tableState}>
      <PageTemplate>
        <ContentStatisticsContainer />
      </PageTemplate>
    </TableContext.Provider>
  )
}

export default ContentStatistics
